import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { postMessage } from 'actions';
import getText from 'context/language/getText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { click } from 'analytics/utilities';
import {
  NavLinkBadge,
  NavLinkIconContainer,
  NavLinkItem,
  NavLinkSubText,
} from './styled';
import { NAVIGATION_ID } from '../constants';

const trackNavClick = (textPath) => {
  const trackingName = textPath
    .replace(/navbar/gi, 'sidenav')
    .replace(/\./g, '_');
  click(trackingName)({});
};

export const NavLink = ({
  badge,
  displayPath,
  icon,
  secondaryText,
  textPath,
  external,
  toRails,
  url,
  name,
  visible,
}) => {
  if (!visible) {
    return null;
  }

  const dispatch = useDispatch();
  const { location } = useHistory();

  const onClick = (e) => {
    trackNavClick(textPath);
    if (toRails) e.preventDefault();
    if (external) {
      e.preventDefault();
      window.open(url);
      return;
    }
    const context = external || toRails ? 'CHANGE_PAGE' : 'REPLACE_PAGE';
    const message = {
      id: NAVIGATION_ID,
      url: displayPath || url,
      context,
    };
    dispatch(postMessage(message));
  };

  return (
    <NavLinkItem active={location.pathname === url}>
      <Link
        to={external ? { pathname: url } : url}
        onClick={onClick}
        data-test-id={`sidenav__link-${name}`}
      >
        {icon && (
          <NavLinkIconContainer>
            <FontAwesomeIcon icon={icon} />
          </NavLinkIconContainer>
        )}
        {getText(textPath)}
        {secondaryText && <NavLinkSubText>{secondaryText}</NavLinkSubText>}
      </Link>
      {badge > 0 && <NavLinkBadge>{badge}</NavLinkBadge>}
    </NavLinkItem>
  );
};

NavLink.propTypes = {
  textPath: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  icon: PropTypes.func,
  secondaryText: PropTypes.string,
  badge: PropTypes.number,
  external: PropTypes.bool,
  displayPath: PropTypes.string,
  toRails: PropTypes.bool,
  name: PropTypes.string,
  visible: PropTypes.bool,
};

NavLink.defaultProps = {
  icon: null,
  secondaryText: undefined,
  badge: 0,
  external: false,
  displayPath: undefined,
  toRails: false,
  name: '',
  visible: true,
};
